// @ts-nocheck e4a195e4
import * as addPanel from '#packages/oldAddPanel';

export default {
  getCategorySections() {
    return addPanel.sections.getSections().other;
  },
};
